import React from 'react';

// Routes
import Routes from './referrals-all-routes';

export default function (props) {

  
  return (
   <div>
       <Routes />
   </div>
  )
}
